<template>
  <div class="join_team">
    <el-form
      :model="joinTeam"
      :rules="rules"
      ref="joinTeam"
      label-width="100px"
    >
      <el-form-item label="团队头像：">
        <el-image
          class="team_avatar"
          :src="teamInfo.icon"
          fit="cover"
        ></el-image>
      </el-form-item>
      <el-form-item label="团队名称：">
        {{ teamInfo.name }}
      </el-form-item>
      <el-form-item label="队长：">
        {{ teamInfo.captainName }}
      </el-form-item>
      <el-form-item label="职务：" prop="postId">
        <el-select v-model="joinTeam.postId" placeholder="请选择职务">
          <el-option
            v-for="item in postList"
            :key="item.postId"
            :label="item.name"
            :value="item.postId"
            :disabled="item.used"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: 60px">
        <el-button class="btn" type="primary" @click="submitForm('joinTeam')"
          >提交</el-button
        >
        <el-button class="btn" @click="resetForm('joinTeam')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { postList } from "@/api/post";
import { teamDetail, joinTeam } from "@/api/team";
export default {
  name: "joinTeam",
  data() {
    return {
      teamInfo: {},
      joinTeam: {
        teamId: this.$route.query.teamId,
        postId: "",
      },
      rules: {
        postId: {
          required: true,
          message: "请选择职务",
          trigger: "blur",
        },
      },
      postList: [],
    };
  },
  created() {
    this.getInfo();
    this.getPostList();
  },
  methods: {
    //   队伍详情
    getInfo() {
      this.$loading.show();
      teamDetail(this.$route.query.teamId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.teamInfo = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 岗位列表
    getPostList() {
      postList({
        classId: this.$route.query.id,
        teamId: this.$route.query.teamId,
      }).then((res) => {
        if (res.code == 0) {
          this.postList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          joinTeam(this.joinTeam).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("申请成功");
              this.$emit("back", true);
              this.$store.commit("SET_UPDATE", true);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("back", true);
    },
  },
};
</script>

<style lang="less" scoped>
.join_team {
  .team_avatar {
    width: 104px;
    height: 104px;
  }

  .btn {
    margin-right: 60px;
    width: 97px;
    height: 40px;
  }
}
</style>